import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ShareService } from "app/service/share/share.service";
import { AuthService } from "../../service/auth/auth.service";
import { CommonService } from "../../service/common/common.service";
import { GtmService } from "../../service/gtm/gtm.service";
import { HttpService } from "../../service/http/http.service";
import { Member, MemberCard } from "../../service/member/member";
import { MemberService } from "../../service/member/member.service";


@Component({
  selector: "app-myinfo-edit",
  templateUrl: "./myinfo-edit.component.html",
  styleUrls: ["./myinfo-edit.component.scss"],
  providers: [MemberService, ShareService],
})
export class MyinfoEditComponent implements OnInit {
  isApp: boolean;
  terms: string;
  me: Member;
  memberCard: MemberCard;

  constructor(
    private authService: AuthService,
    private shareService: ShareService,
    private memberService: MemberService,
    private httpService: HttpService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private gtmService: GtmService
  ) {
    let userAgent = window.navigator.userAgent;
    this.isApp = userAgent.indexOf("hey_application") > -1;
  }

  onCanDeactivate(): boolean {
    if (this.authService.getEmail() && (!this.me.name || !this.me.nick)) {
      window.alert("내 정보를 작성하셔야 다른 메뉴 이용이 가능합니다.");
      return false;
    }

    return true;
  }

  ngOnInit() {
    this.shareService.awaitMe().subscribe((me) => {
      this.me = me;

      let works = !!this.me.work
        ? this.me.work.split(",").map((work) => work.trim())
        : [];
      this.selectedWorks = this.works.map((work) => works.includes(work));

      if (works.length > 0) {
        if (!this.works.includes(works[works.length - 1])) {
          this.workEtc = works[works.length - 1];
          this.selectedWorkEtc = true;
        }
      }

      let interests = !!this.me.interest
        ? this.me.interest.split(",").map((interest) => interest.trim())
        : [];
      this.selectedInterest = this.interest.map((interest) =>
        interests.includes(interest)
      );

      if (interests.length > 0) {
        if (!this.interest.includes(interests[interests.length - 1])) {
          this.InterestEtc = interests[interests.length - 1];
          this.selectedInterestEtc = true;
        }
      }

      this.gtmService.pageViewWithPage({
        path: this.route.snapshot["_routerState"].url,
        title: "내 정보 수정",
        breadcrumb: "Home > Member > 내 정보 수정",
      });
    });

    this.httpService.get(`/api/members/me/card`).toPromise()
      .then(
        (data) => {
          this.memberCard = data.json();
        },
      ).catch(error => {
      });
  }

  works: string[] = [
    "개발",
    "디자인",
    "영업",
    "마케팅",
    "브랜딩",
    "홍보",
    "컨설팅",
    "고객서비스",
    "생산/제조",
    "기획",
    "운영",
    "강의/교육",
    "연구/리서치",
    "인사",
    "총무",
    "재무/회계",
    "전략/경영",
  ];
  selectedWorks: boolean[] = [];
  workEtc: string;
  selectedWorkEtc: boolean = false;

  interest: string[] = [
    "디자인/디자인씽킹",
    "여행",
    "음악/공연",
    "영화",
    "스포츠/운동/건강",
    "체인지메이커",
    "소셜임팩트/섹터",
    "스타트업/벤처",
    "마케팅/브랜딩",
    "육아",
    "책/독서/글쓰기",
    "맛집/요리/음식",
    "문화/예술",
    "커뮤니티/공동체",
    "인사/조직",
    "커리어/역량/성장",
    "사진/포토샵",
    "영상/촬영/편집",
    "환경/지속가능성/에너지",
    "동물",
    "국제개발/협력",
    "교육",
    "심리/치유",
    "일러스트/드로잉",
    "도시/건축/조경",
    "테크/IT/개발",
    "금융/재테크",
    "게임",
  ];
  selectedInterest: boolean[] = [];
  InterestEtc: string;
  selectedInterestEtc: boolean = false;
  birthYear: string;

  onUpdate(me: Member) {
    this.onRemoveSpecialChar(this.workEtc);

    me.id = this.me.id;
    me.email = this.me.email;
    me.birthYear = this.birthYear || this.me.birthYear;

    me.work = this.selectedWorks
      .map((value, index) => (value ? this.works[index] : ""))
      .filter((value) => value)
      .join(", ");
    if (this.selectedWorkEtc)
      me.work = me.work + (me.work.length ? ", " : "") + this.workEtc;

    me.interest = this.selectedInterest
      .map((value, index) => (value ? this.interest[index] : ""))
      .filter((value) => value)
      .join(", ");
    if (this.selectedInterestEtc)
      me.interest =
        me.interest + (me.interest.length ? ", " : "") + this.InterestEtc;

    if (!me.name) {
      window.alert("이름을 입력해 주세요.");
      return;
    } else if (!me.nick) {
      window.alert("닉네임을 입력해 주세요.");
      return;
    } else if (!me.work) {
      window.alert("직업/담당업무를 선택해 주세요.");
      return;
    } else if (this.selectedWorkEtc && !this.workEtc) {
      window.alert("직업/담당업무 기타를 입력해 주세요.");
      return;
    } else if (!me.contact) {
      window.alert("연락처를 입력해 주세요.");
      return;
    } else if (!this.validatePhoneNumber(me.contact)) {
      window.alert("올바른 연락처를 입력해 주세요.");
      return;
    } else if (!me.seatNo) {
      window.alert("업무공간(좌석번호)을 선택해 주세요.");
      return;
    } else if (!me.birthYear) {
      window.alert("생년월일을 선택해 주세요.");
      return;
    } else if (!me.interest) {
      window.alert("관심사를 최소 1개이상 입력해 주세요.");
      return;
    }

    this.memberService.updateMe(me).subscribe((me) => {
      this.me = me;
      this.commonService.addMyinfoEvent();
      this.router.navigateByUrl("/member/mypage");
      this.shareService.refreshMe();
    });
  }

  onRemoveSpecialChar(content: string) {
    if (content)
      this.workEtc = content
        .replace(/[\{\}\[\]?.,;:|\)*~`!^\-_+┼<>@\#$%&\'\"\\(\=]/gi, "")
        .trim();
    else this.workEtc = "";
  }

  resetPassword() {
    if (window.confirm("로그아웃 및 비밀번호 재설정 메일이 전송됩니다.")) {
      this.memberService.findPassword(this.me.email).subscribe((res) => {
        this.httpService.logout();
        this.router.navigateByUrl("/login");
      });
    }
  }

  onNumberCheck(phone: string) {
    return phone.replace(/[^0-9\.]+/g, "");
  }

  validatePhoneNumber(phone: string) {
    const phoneRex = /^\d{2,3}\d{3,4}\d{4}$/;

    return phoneRex.test(phone);
  }

  // 탈퇴 처리
  leaveModal = {
    show: false,
  };

  handleLeave() {
    console.debug("handleLeave");
    this.leaveModal.show = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/member/myinfo-edit/myinfo-edit.component.ts